module.exports = __webpack_public_path__ + "static/nav_bg-cb0f1e822beaed8a9664be0230cc8f47.jpg";